@if (isLoading) {
	<div class="overlay-new"></div>
}

<div class="service-header-wrapper">
	<h2 class="mat-heading">{{ 'mes.administration.terminal.terminal' | translate }}</h2>
	<div class="service-header-buttons">
		<div class="acies-density-high acies-list-search-field">
			<mat-form-field>
				<input matInput (keyup)="applyFilter($event)" [placeholder]="'insights.administration.users.search' | translate" #input [cdkTrapFocusAutoCapture]="showSearch" [cdkTrapFocus]="showSearch" />
				<button mat-icon-button matPrefix>
					<mat-icon svgIcon="acies_search"></mat-icon>
				</button>
			</mat-form-field>
		</div>
		<header-sub-menu [favoriteItems]="favoriteItems" [menuItems]="menuItems"></header-sub-menu>
	</div>
</div>

<div class="table-wrapper">
	<table mat-table recycleRows [dataSource]="dataSource" matSort (matSortChange)="onSort($event)">
		<ng-container matColumnDef="name">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>
				{{ 'mes.administration.terminal.shared.name' | translate }}
			</th>
			<td mat-cell *matCellDef="let element">({{ element.alias }}) {{ element.name }}</td>
		</ng-container>
		<ng-container matColumnDef="nextTerminal">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>
				{{ 'mes.administration.terminal.shared.next-terminal' | translate }}
			</th>
			<td mat-cell *matCellDef="let element">{{ element.nextTerminal }}</td>
		</ng-container>
		<ng-container matColumnDef="terminalTemplate">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>
				{{ 'mes.administration.terminal.shared.terminal-template' | translate }}
			</th>
			<td mat-cell *matCellDef="let element">{{ element.terminalTemplate }}</td>
		</ng-container>
		<ng-container matColumnDef="menu">
			<th mat-header-cell *matHeaderCellDef style="text-align: end"></th>
			<td mat-cell *matCellDef="let row" style="text-align: end">
				<button mat-icon-button [matMenuTriggerFor]="menu">
					<mat-icon mat-list-icon svgIcon="acies_overflow_menu" style="padding-top: 5px"></mat-icon>
				</button>
				<mat-menu #menu="matMenu">
					<button [appDisableWithoutPermission]="['mes:TerminalGet', 'mes:ScanningPrefixGet']" mat-menu-item (click)="openTerminal(row.terminal)">
						<span>{{ 'mes.administration.terminal.shared.openbtn' | translate }}</span>
					</button>
					<button [appDisableWithoutPermission]="['mes:TerminalUpdate', 'mes:TerminalGet', 'mes:WorkTaskGet', 'mes:IncidentCodeGet', 'print:PrinterGet', 'docs:TemplateGetList']" mat-menu-item (click)="openEditTerminal(row.terminal)">
						<span>{{ 'mes.administration.terminal.shared.editbtn' | translate }}</span>
					</button>
					<button [appDisableWithoutPermission]="['mes:TerminalDelete', 'mes:TerminalGet']" mat-menu-item (click)="openDeleteTerminal(row.terminal)">
						<span>
							{{ 'mes.administration.terminal.shared.deletebtn' | translate }}
						</span>
					</button>
				</mat-menu>
			</td>
		</ng-container>
		<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
	</table>
</div>

<mat-paginator [pageSizeOptions]="[10, 20, 50, 100, 200, 500, 1000, 2000, 5000]" [pageSize]="1000" showFirstLastButtons></mat-paginator>
